var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccordianOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00584 0.334792L0.918662 6.22087C0.817681 6.31755 0.737531 6.43257 0.682834 6.55929C0.628137 6.68602 0.599976 6.82195 0.599976 6.95923C0.599976 7.09652 0.628137 7.23244 0.682834 7.35917C0.737531 7.4859 0.817681 7.60092 0.918662 7.69759C1.12052 7.89128 1.39358 8 1.67821 8C1.96284 8 2.2359 7.89128 2.43776 7.69759L7.82465 2.54987L13.1577 7.69759C13.3595 7.89128 13.6326 8 13.9172 8C14.2018 8 14.4749 7.89128 14.6768 7.69759C14.7786 7.60128 14.8595 7.48642 14.915 7.35968C14.9705 7.23293 14.9994 7.09682 15 6.95923C14.9994 6.82164 14.9705 6.68553 14.915 6.55879C14.8595 6.43204 14.7786 6.31719 14.6768 6.22087L8.58958 0.334792C8.4887 0.229232 8.36625 0.144988 8.22996 0.0873676C8.09368 0.0297471 7.9465 8.76064e-08 7.79771 8.58321e-08C7.64892 8.40579e-08 7.50175 0.0297471 7.36546 0.0873676C7.22917 0.144988 7.10673 0.229232 7.00584 0.334792Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordianOpen);
export default __webpack_public_path__ + "static/media/accordian-open.797f64416d0797a86d2cd7f6c06ba13d.svg";
export { ForwardRef as ReactComponent };